import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Signin from '@/views/Signin.vue'
import LandingPage from '@/views/LandingPage.vue'
import store from '@/store'


Vue.use(VueRouter)

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
            fullScreen: true,
            disableAuth: true
        }
    },
    {
        path: '/signin',
        name: 'SignIn',
        component: Signin,
        meta: {
            fullScreen: true,
            disableAuth: true
        }
    },
    {
        path: '/',
        name: 'Home',
        component: LandingPage,
    },
    {
        path: '/rooms/approval',
        redirect: '/freeroom/admin/approval',
    },
]

const router = new VueRouter({
    mode: 'history',
    routes
})


router.beforeEach(async (to, from, next) => {
    if (store.getters['Auth/isAuthenticated']) {
        // already signed in, we can navigate anywhere
        next()

    } else if (!to.meta.disableAuth) {
        // authentication is required. Trigger the sign in process
        await store.dispatch('Auth/authenticate')
        if(store.getters['Auth/isAuthenticated']){
            next()
        } else {
            await store.dispatch('Global/setCorporateNoticeDisplayed', false)
            next({path: '/login'})
        }
    } else {
        // No auth required. We can navigate
        next()
    }
})
// eslint-disable-next-line no-unused-vars
router.afterEach(async (to, from) => {
    window.gtag('config', process.env.VUE_APP_GT_TAG, {
        'page_title': to.name,
        'page_path': to.path
    })
})


export default router
